import React from "react";
import { Route, Switch } from "react-router-dom";

import * as SiteFileQL from "queries/site-file";
import SiteFilePublicSchema from "@common/schema/site-file/public";
import * as Section from "@repoflow/components/section";
import { Crumb, useCrumbLabel } from "@repoflow/components/breadcrumb";

import * as ViewRoute from "./view";
import * as EditRoute from "./edit";
import * as RemoveRoute from "./remove";

const LocalProvider = ({
  match: {
    params,
    params: { fileId },
  },
  children: Children,
}) => {
  const { base: parentBase, basepath: parentBasepath } =
    Section.useSectionContext();

  const base = `${parentBase}/${fileId}`;
  const basepath = `${parentBasepath}/:fileId`;

  // Keyed on the entity, for the reason recorded on the page and section routes:
  // the screens below seed their form state once, from the row this route
  // resolved, and moving from one file to another has to reset them.
  return (
    <Section.Provider
      key={fileId}
      schema={SiteFilePublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ params }) => (
        <Section.Query
          query={SiteFileQL.get}
          variables={params}
          datapath={"sites.get.files.get"}
        >
          {ContentHandler}
        </Section.Query>
      )}
    </LocalProvider>
  );
}

function ContentHandler({ basepath }) {
  return (
    <Switch>
      <Route path={`${basepath}/remove`} component={RemoveRoute.Content} />
      <Route path={`${basepath}/edit`} component={EditRoute.Content} />
      <Route path={`${basepath}`} component={ViewRoute.Content} />
    </Switch>
  );
}

// The fileId is a uuid bucketws minted and says nothing to anyone; `name` is
// what the person called the file when they picked it, and is the only reason
// this service stores a name at all.
function FileCrumb({ base, siteId, kind, fileId }) {
  const label = useCrumbLabel({
    query: SiteFileQL.get,
    variables: { siteId, kind, fileId },
    datapath: "sites.get.files.get.name",
    fallback: fileId,
  });

  return <Crumb to={base} label={label} />;
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath, params: { siteId, kind, fileId } }) => (
        <>
          <FileCrumb base={base} siteId={siteId} kind={kind} fileId={fileId} />

          <Switch>
            <Route path={`${basepath}/remove`} component={RemoveRoute.Indice} />
            <Route path={`${basepath}/edit`} component={EditRoute.Indice} />
            <Route path={`${basepath}`} component={ViewRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => <></>;
